// extracted by mini-css-extract-plugin
export var arrows = "_40-6";
export var decrementer = "_40-a";
export var disabled = "_40-4";
export var error = "_40-1";
export var hiddenText = "_40-b";
export var incrementer = "_40-9";
export var input = "_40-8";
export var inputWrapper = "_40-0";
export var leadingIcon = "_40-c";
export var readonly = "_40-3";
export var regular = "_40-7";
export var small = "_40-5";
export var warning = "_40-2";